import { FC } from 'react';
import { Icon } from '@chakra-ui/react';

import { TenantAsset } from '~/core/shared/assets';
import { useAsset } from '~/core/shared/contexts';
import { MiddleOfficeLogoProps } from './types';

export const MiddleOfficeLogo: FC<MiddleOfficeLogoProps> = ({
  variant = 'light',
}) => {
  const Logo = useAsset(
    variant === 'light'
      ? TenantAsset.LogoHorizontalLight
      : TenantAsset.LogoHorizontalDark,
  );

  return <Icon as={Logo} h="40px" w="auto" />;
};
